import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Image from '@components/Image';
import useMenuSectionImage from '@hooks/images/useMenuSectionImage';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';

const MOBILE_HEIGHT = 48;
const DESKTOP_HEIGHT = 62;

const SectionImage = styled(Image)`
  height: ${({ imageHeight }) => imageHeight}px;
`;

function MenuSectionImage({ image, country }) {
  const isDesktopLayout = useIsDesktopLayout();
  const imageHeight = isDesktopLayout ? DESKTOP_HEIGHT : MOBILE_HEIGHT;
  const imageSrc = useMenuSectionImage({
    image,
    height: imageHeight,
    country,
    isDesktopLayout,
  });

  if (!imageSrc) return null;

  return (
    <SectionImage
      src={imageSrc}
      className="full_width"
      imageHeight={imageHeight}
    />
  );
}

MenuSectionImage.propTypes = {
  image: PropTypes.string,
  country: PropTypes.string.isRequired,
};

export default MenuSectionImage;
